export default class MouseState {
	constructor(params) {
		if (params.down !== undefined)
			this.down = params.down;
		if (params.move !== undefined)
			this.move = params.move;
		if (params.up !== undefined)
			this.up   = params.up;
		if (params.click !== undefined)
			this.click = params.click;
		if (params.longpress != undefined)
			this.longpress = params.longpress;
		if (params.longclick !== undefined)
			this.longclick = params.longclick;
	}
}
